/** @jsx jsx */
import { css } from '@emotion/react';
import { N30 } from '@atlaskit/theme/colors';
export const svgIconStyles = css({
  button: {
    svg: {
      pointerEvents: 'none'
    }
  }
});

// This style is copied from packages/editor/editor-core/src/ui/styles.ts
export const wrapperStyle = css({
  display: 'flex',
  alignItems: 'center',
  '> div, > span': {
    display: 'flex'
  },
  '> div > div': {
    display: 'flex'
  },
  marginLeft: 0,
  minWidth: 'auto'
});

// This style is copied from packages/editor/editor-core/src/ui/styles.ts
export const separatorStyles = css({
  background: `var(--ds-border, ${N30})`,
  width: '1px',
  height: '24px',
  display: 'inline-block',
  margin: `0 ${"var(--ds-space-100, 8px)"}`,
  userSelect: 'none'
});